import React from 'react';
import MemberAdmin from '../inventory/MemberAdmin';
import RemsAccessAdmin from './RemsAccessAdmin';
import '../inventory/inventory.css';
import '../inventory/member-admin.css';
import './admin.css';

export default function MemberManagement({ profile }) {
  if (!profile?.is_admin || String(profile?.member_kind || 'line_medic') !== 'line_medic') {
    return (
      <div className="admin-root">
        <main className="admin-page">
          <section className="admin-card admin-denied">
            <h1>Admin access required</h1>
            <p>Your member account does not have program-admin access.</p>
            <button type="button" onClick={() => window.location.assign('/')}>Back to Dashboard</button>
          </section>
        </main>
      </div>
    );
  }

  return (
    <div className="admin-root">
      <header className="admin-topbar">
        <div>
          <h1>Member Management</h1>
          <p>Line Medic accounts, REMS Quick Access verification, program-admin access, and notification roles</p>
        </div>
        <div className="admin-topbar-actions">
          <button type="button" onClick={() => window.location.assign('/admin')}>Admin Home</button>
          <button type="button" onClick={() => window.location.assign('/')}>Member Dashboard</button>
        </div>
      </header>
      <main className="admin-page">
        <MemberAdmin />
        <RemsAccessAdmin />
      </main>
    </div>
  );
}
